import { Inject, Injectable, Optional } from '@angular/core';
import { ClienteResponse, CustomerApiService } from 'src/app/api';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { PerfilService } from '../ajs-perfil.service';
import { CustomerService, UpdateCustomer } from '../customer.service';
import { CacheableGet } from './cacheable-get';
import { FIVE_MINUTES_IN_MILLIS, PROFILE_CACHE_TIME } from './consts';

@Injectable({
  providedIn: 'root'
})
export class ProfilePickupService {

  private getRequest: CacheableGet<ClienteResponse>;

  private get currentUserId() {
    const user = this.perfilService.getCacheUserData();

    return user && user.id || 0;
  }

  public get shouldUpdate() {
    return this.getRequest.shouldUpdate;
  }

  constructor(
    private customerApiService: CustomerApiService,
    private customerService: CustomerService,
    private perfilService: PerfilService,
    @Optional() @Inject(PROFILE_CACHE_TIME) cacheTime: number,
  ) {
    if (!cacheTime) {
      cacheTime = FIVE_MINUTES_IN_MILLIS;
    }

    this.getRequest = new CacheableGet<ClienteResponse>(
      cacheTime,
      () => this.customerApiService.getCustomerById(this.currentUserId),
    );
  }

  /**
   * Obtém os dados para o cliente atual
   */
  public getCustomer(): Observable<ClienteResponse> {
    return this.getRequest.get();
  }

  /**
   * Define a integração para o usuário
   *
   * @param provider Slug da integração
   */
  public setCustomer(data: UpdateCustomer): Observable<void> {
    return this.customerService.updateCustomer(this.currentUserId, data).pipe(
      tap(() => this.getRequest.markForUpdate()),
    );
  }
}
